import React from 'react';
import { genericActionsIds } from '../../utilities/constants';
import ButtonComponent from './buttonComponent';
import { ReactComponent as ChevronLeftIcon } from 'assets/icons/chevron-left.svg';
import { useGetGenericActions } from '../../hooks/useGetGenericActions';
import { useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface BackButtonProps {
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ className }) => {
  const navigate = useNavigate();
  const { data: genericAction, loading: genericActionLoading } =
    useGetGenericActions({
      locale: 'en',
      genericActionId: [genericActionsIds.BACK],
    });

  const canGoBack = window.history.state && window.history.state.idx > 0;

  if (genericActionLoading || !genericAction || !canGoBack) {
    return null;
  }

  return (
    <ButtonComponent
      type="underline"
      className={twMerge('!text-sm uppercase !w-fit mb-2', className)}
      Icon={ChevronLeftIcon}
      iconPosition="left"
      iconWidth="w-[6px]"
      iconHeight="h-[12px]"
      testID="back"
      onClick={() => navigate(-1)}
    >
      {genericAction?.[genericActionsIds.BACK]?.back ?? 'Back'}
    </ButtonComponent>
  );
};

export default BackButton;
